import { Component, OnInit, HostBinding, Input } from '@angular/core';

@Component({
	selector: 'm-timeline-item',
	templateUrl: './timeline-item.component.html'
})
export class TimelineItemComponent implements OnInit {
	@Input() item: any;

	@HostBinding('class') classes = 'm-list-timeline__item';

	constructor() { }

	ngOnInit() {
		if (this.item.read) {
			this.classes += ' m-list-timeline__item--read';
		}
	}

	badgeClass(tag: string) {
		const badges: any = {
			urgent: 'm-badge--info',
			important: 'm-badge--warning',
			resolved: 'm-badge--success',
			pending: 'm-badge--danger'
		};
		return badges[tag];
	}
}
